import React from 'react';
import {
    SwapHoriz,
    QrCode,
    Link,
    TrendingUp
} from '@mui/icons-material';

const TransactionStats = ({ currency, timeRange, transactions = [], loading = false }) => {
    // Calculer les statistiques réelles
    const completedTransactions = transactions.filter(t => t.status === 'completed');
    const paymentRequests = transactions.filter(t => t.type === 'paymentRequest');
    const paymentLinks = transactions.filter(t => t.type === 'paymentLink');
    
    const totalRevenue = completedTransactions
        .filter(t => t.currency === currency)
        .reduce((sum, t) => sum + (t.netAmount || t.amount || 0), 0);

    const stats = {
        totalTransactions: {
            value: transactions.length,
            label: 'Total Transactions',
            icon: SwapHoriz,
            color: 'from-blue-500 to-cyan-500',
            change: '+0%' // À calculer si historique disponible
        },
        paymentRequests: {
            value: paymentRequests.length,
            label: 'Demandes Paiement',
            icon: QrCode,
            color: 'from-purple-500 to-pink-500',
            change: '+0%'
        },
        paymentLinks: {
            value: paymentLinks.length,
            label: 'Liens de Paiement',
            icon: Link,
            color: 'from-green-500 to-emerald-500',
            change: '+0%'
        },
        revenue: {
            value: totalRevenue,
            label: 'Chiffre Affaires',
            icon: TrendingUp,
            color: 'from-amber-500 to-yellow-500',
            change: '+0%',
            isAmount: true
        }
    };

    if (loading) {
        return (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm animate-pulse">
                        <div className="h-4 bg-gray-200 rounded w-3/4 mb-3"></div>
                        <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
                        <div className="h-3 bg-gray-200 rounded w-2/3"></div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {Object.entries(stats).map(([key, stat]) => {
                const Icon = stat.icon;
                const displayValue = stat.isAmount 
                    ? `${currency === 'USD' ? '$' : ''}${stat.value.toLocaleString()}${currency === 'CDF' ? ' FC' : ''}`
                    : stat.value.toLocaleString();
                
                return (
                    <div key={key} className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <div className="flex items-center justify-between">
                            <div className="flex-1">
                                <p className="text-sm font-medium text-gray-600">{stat.label}</p>
                                <p className="text-2xl font-bold text-gray-900 mt-1">
                                    {displayValue}
                                </p>
                                {stat.change && (
                                <div className="flex items-center space-x-1 mt-2">
                                    <span className={`text-xs font-medium ${
                                        stat.change.startsWith('+') ? 'text-green-600' : 'text-red-600'
                                    }`}>
                                        {stat.change}
                                    </span>
                                    <span className="text-xs text-gray-500">vs période précédente</span>
                                </div>
                                )}
                            </div>
                            <div className={`w-12 h-12 bg-gradient-to-r ${stat.color} rounded-2xl flex items-center justify-center`}>
                                <Icon className="text-white text-lg" />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TransactionStats;